export const MaxWidths = {
  l: "1300px",
  m: "1024px",
  copy: "60ch",
}
